import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { AppPath } from '../../../AppPath'
import { CheckoutSuccess } from '../checkout'
import { ProposalPath } from '../ProposalPath'

export const ProposalPolicyRoutes: FunctionComponent = () => (
  <Routes>
    <Route
      key='checkout'
      path={ProposalPath.CHECKOUT + AppPath.WILDCARD}
      element={<CheckoutSuccess />}
    />
    <Route path='*' element={<Navigate to={AppPath.HOME} />} />
  </Routes>
)
